import { render } from "./CartAvvisi.vue?vue&type=template&id=1a5ab801&scoped=true"
import script from "./CartAvvisi.vue?vue&type=script&lang=js"
export * from "./CartAvvisi.vue?vue&type=script&lang=js"

import "./CartAvvisi.vue?vue&type=style&index=0&id=1a5ab801&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5ab801"]])

export default __exports__